// src/libs/axios.js
import axios from 'axios'
import CryptoJS from 'crypto-js'
import router from '@/router'

// 建立 axios instance
const api = axios.create({
 // baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000,
})

const SECRET = process.env.VUE_APP_TIMESTAMP_SECRET || 'gUPfG3LUOgr0snt7eB0L'

function encrypt(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET).toString()
}

function decrypt(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET)
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
}

function buildBodyHash(data) {
  if (typeof data === 'undefined' || data === null) {
    return CryptoJS.SHA256('').toString(CryptoJS.enc.Hex)
  }

  if (typeof FormData !== 'undefined' && data instanceof FormData) {
    return CryptoJS.SHA256('[form-data]').toString(CryptoJS.enc.Hex)
  }

  if (typeof data === 'string') {
    return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex)
  }

  return CryptoJS.SHA256(JSON.stringify(data)).toString(CryptoJS.enc.Hex)
}

// Request 攔截器：自動加上 token、timestamp(加密)、nonce 同 checksum
api.interceptors.request.use(
  config => {
    config.headers = config.headers || {}

    const token = localStorage.getItem('token') || localStorage.getItem('Token')
    const timestamp = Math.floor(Date.now() / 1000).toString()
    const encryptedTimestamp = encrypt({ timestamp })
    const nonce = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex)
    const method = (config.method || 'get').toUpperCase()
    const requestUrl = config.url || ''
    const bodyHash = buildBodyHash(config.data)

    const signingPayload = [encryptedTimestamp, nonce, method, requestUrl, bodyHash].join('.')

    config.headers['x-timestamp'] = encryptedTimestamp
    config.headers['x-nonce'] = nonce

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers['x-checksum'] = CryptoJS.HmacSHA256(signingPayload, token).toString(CryptoJS.enc.Hex)
    }

    return config
  },
  error => Promise.reject(error)
)

// Response 攔截器：攔截 401，自動 logout
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // 清除 localStorage 裡的登入資料
      localStorage.removeItem('token')
      localStorage.removeItem('userData')
      localStorage.removeItem('socket_id')

      // 防止重複導向
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

export default api
